import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'sc-insurer-footer',
  styleUrls: ['./insurer-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="footer-container">
      <p class="footer-body-text sc-design-text-4">
        {{ 'InsurerFooter.bodyText' | translate }}
      </p>
    </div>
  `,
  imports: [TranslateModule],
})
export class InsurerFooterComponent {}
